module.exports = "/lucky-balls/img/bonus_green/check_infoBar/check_007.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_green/check_infoBar/check_007.png
// module id = 930
// module chunks = 0